import { getSlidesConfig } from "@/api/slides";

const getDefaultState = () => {
    return { all: {} };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getSlidesConfig({ commit, state, dispatch }) {
        if (Object.keys(state.all).length === 0) {
            commit("setLoading", true, { root: true });
        }
        getSlidesConfig().then((response) => {
            if (response.data.Status === 200) {
                commit("setSlidesConfig", response.data.Result);
            } else if (
                response.data.Status === 400 &&
                response.data.Errors &&
                response.data.Errors.GeneralCsrfToken
            ) {
                dispatch("getSlidesConfig");
            }
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setSlidesConfig(state, slides) {
        state.all = slides;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
